/**
* Sanitise subdomain before attempting to register.
*
* 1. Lowercase the company name.
* 2. Remove any special characters.
*/
export default function sanitiseSubdomain(companyName) {
    return companyName.toLowerCase().replace(/[^a-z0-9]/g, '');
}


// WEBPACK FOOTER //
// ./src/utils/SubdomainValidator.js